import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import BatchStatusBadge from './BatchStatusBadge';
import ProcessingProgressBar from './ProcessingProgressBar';

export default function BatchMobileCard({ batch, isSelected, onSelect, onViewDetail, onEditBatch, onStatusChange }) {
  const [expanded, setExpanded] = useState(false);
  const marginDiff = batch?.actualMargin !== null ? batch?.actualMargin - batch?.expectedMargin : null;

  return (
    <div className={`bg-white border rounded-xl overflow-hidden transition-all ${isSelected ? 'border-orange-400 shadow-md' : 'border-slate-200'}`}>
      {/* Header */}
      <div className="flex items-start gap-3 p-4">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={e => onSelect(batch?.id, e?.target?.checked)}
          className="w-4 h-4 mt-0.5 rounded border-slate-300 text-orange-600 focus:ring-orange-500 flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2 flex-wrap">
            <span className="font-mono text-sm font-bold text-slate-800">{batch?.batchId}</span>
            <BatchStatusBadge status={batch?.status} />
          </div>
          <p className="text-sm font-medium text-slate-700 mt-0.5" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>
            {batch?.metal} — {batch?.category}
          </p>
          <p className="text-xs text-slate-500 mt-0.5" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>
            Compra: {batch?.purchaseDate}
          </p>
        </div>
        <button onClick={() => setExpanded(v => !v)} className="p-1 text-slate-400 hover:text-slate-600 flex-shrink-0">
          <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size={18} color="currentColor" />
        </button>
      </div>
      {/* Progress */}
      <div className="px-4 pb-3">
        <ProcessingProgressBar percentage={batch?.progress} status={batch?.status} />
      </div>
      {/* Expanded Details */}
      {expanded && (
        <div className="border-t border-slate-100 px-4 py-3 bg-slate-50 space-y-2">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <p className="text-xs text-slate-500" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>Margen Esperado</p>
              <p className="text-sm font-mono font-semibold text-slate-700">{batch?.expectedMargin?.toFixed(1)}%</p>
            </div>
            <div>
              <p className="text-xs text-slate-500" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>Margen Real</p>
              {marginDiff !== null ? (
                <p className={`text-sm font-mono font-semibold ${marginDiff >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                  {marginDiff >= 0 ? '+' : ''}{marginDiff?.toFixed(1)}%
                </p>
              ) : <p className="text-sm text-slate-400">—</p>}
            </div>
            <div>
              <p className="text-xs text-slate-500" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>Días Restantes</p>
              <p className={`text-sm font-mono font-semibold ${batch?.daysRemaining !== null && batch?.daysRemaining <= 3 ? 'text-red-600' : 'text-slate-700'}`}>
                {batch?.daysRemaining !== null ? `${batch?.daysRemaining}d` : '—'}
              </p>
            </div>
            <div>
              <p className="text-xs text-slate-500" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>Peso (kg)</p>
              <p className="text-sm font-mono font-semibold text-slate-700">{batch?.weight?.toLocaleString('es-ES')}</p>
            </div>
          </div>
        </div>
      )}
      {/* Actions */}
      <div className="flex border-t border-slate-100">
        <button onClick={() => onViewDetail(batch)} className="flex-1 flex items-center justify-center gap-1.5 py-2.5 text-xs text-blue-600 hover:bg-blue-50 transition-colors">
          <Icon name="Eye" size={14} color="currentColor" />
          <span style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>Ver</span>
        </button>
        <button onClick={() => onEditBatch(batch)} className="flex-1 flex items-center justify-center gap-1.5 py-2.5 text-xs text-orange-600 hover:bg-orange-50 transition-colors border-x border-slate-100">
          <Icon name="Pencil" size={14} color="currentColor" />
          <span style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>Editar</span>
        </button>
        <button onClick={() => onStatusChange(batch)} className="flex-1 flex items-center justify-center gap-1.5 py-2.5 text-xs text-emerald-600 hover:bg-emerald-50 transition-colors">
          <Icon name="RefreshCw" size={14} color="currentColor" />
          <span style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>Estado</span>
        </button>
      </div>
    </div>
  );
}